<template>
  <div>
    <div class="">
      <img class="topimg" src="" alt="" />
      <div class="lead-text">
        <span>导语:</span>
        {{ leadtext }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    };
  },

  props: ["leadtext"],
};
</script>

<style scoped>
.topimg{
  width: 100%;
}
.lead-text {
  background-color: #ffffff;
  padding: 36px;
  border-radius: 14px 14px 0px 0px;
  color: #333333;
  font-size: 20px;
  font-family: 'PingFang-SC-Regular';
  line-height: 25px;
  text-align: justify;
  display: flex;
border: 4px solid;
border-image: linear-gradient(270deg, rgba(56, 18, 178, 0.5), rgba(250, 29, 129, 0.5)) 4 4;
}
.lead-text span {
    font-weight: bold;
    color: #4613ae;
    width: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/comhead.vue